import React, { isValidElement } from 'react';

import { Box, Grid, Typography } from '@sbv-clients/ui-shared';

export function SendRight({ children }: { children: React.ReactNode }) {
  return <Box>{children}</Box>;
}

export function MyTitleArea({
  children,
  title,
  displayChildrenUnder,
}: {
  children?: React.ReactNode;
  title?: string;
  displayChildrenUnder?: boolean;
}) {
  return !displayChildrenUnder ? (
    <Grid container spacing={2} alignItems={'center'}>
      <Grid>
        <Typography gutterBottom={false} variant={'h4'}>
          {title}
        </Typography>
      </Grid>
      {React.Children.map(children, (child, i) => (
        <Grid offset={{ xs: i === 0 ? 'auto' : undefined }}>{child}</Grid>
      ))}
    </Grid>
  ) : (
    <Grid container>
      <Grid direction={'column'} container spacing={2}>
        <Grid>
          <Typography gutterBottom={false} variant={'h4'}>
            {title}
          </Typography>
        </Grid>
        <Grid container spacing={2}>
          {React.Children.map(children, (child) => {
            if (!(isValidElement(child) && child.type === SendRight)) {
              return <Grid>{child}</Grid>;
            }
          })}
        </Grid>
      </Grid>
      <Grid
        offset={{ xs: 'auto' }}
        container
        direction={'column-reverse'}
        spacing={2}
      >
        {React.Children.map(children, (child) => {
          if (isValidElement(child) && child.type === SendRight) {
            return <Grid>{child}</Grid>;
          }
        })}
      </Grid>
    </Grid>
  );
}
